import React from 'react';
import { Player, Bid } from '../../types';
import {
  PLAYER_CARD_BASE,
  PLAYER_CARD_SELF,
  PLAYER_CARD_OTHER,
  PLAYER_CARD_ACTIVE,
} from '../../constants/styles';
import {
  getPlayerStatusEmoji,
  getConnectionStatusColor,
  formatBid,
} from '../../utils/playerUtils';

interface PlayerCardProps {
  player: Player;
  isCurrentPlayer: boolean;
  isSelf: boolean;
  isPlaying: boolean;
  isWaiting: boolean;
  lastBid: Bid | null;
}

const PlayerCard: React.FC<PlayerCardProps> = ({
  player,
  isCurrentPlayer,
  isSelf,
  isPlaying,
  isWaiting,
  lastBid,
}) => {
  const baseClass = PLAYER_CARD_BASE;
  const variantClass = isSelf ? PLAYER_CARD_SELF : PLAYER_CARD_OTHER;
  const activeClass = isCurrentPlayer && isPlaying ? PLAYER_CARD_ACTIVE : '';
  const isEliminated = !isWaiting && player.dice.length === 0;

  return (
    <div className={`${baseClass} ${variantClass} ${activeClass}`.trim()}>
      <div className="flex items-center gap-1">
        <span className="text-sm">
          {getPlayerStatusEmoji(player, isEliminated)}
        </span>
        <div className={`w-2 h-2 rounded-full ${getConnectionStatusColor(player, isWaiting)}`} />
        <p className="text-xs font-semibold text-gray-900 dark:text-white whitespace-nowrap">
          {player.name}{isSelf && ' (You)'}
        </p>
      </div>
      {!isWaiting && (
        <p className="text-xs text-gray-600 dark:text-gray-400">
          {player.dice.length} dice
          {lastBid && ` 💬 ${formatBid(lastBid.quantity, lastBid.faceValue)}s`}
        </p>
      )}
    </div>
  );
};

export default PlayerCard;